import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import request from '../config/request';

const useBanner = () => {
  const userToken = useSelector(state => state.auth.userToken);
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBanners = async () => {
      if (!userToken) return;
      setLoading(true);
      setError(null);
      try {
        const res = await request.get('/banner/bannerlist', {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        setBanners(res.data.data || []);
      } catch (err) {
        console.error('Banner fetch error:', err);
        setError(err.message || 'Failed to fetch banners');
      } finally {
        setLoading(false);
      }
    };

    fetchBanners();
  }, [userToken]);

  return { banners, loading, error };
};

export default useBanner;
